import { render } from "./Favourites.vue?vue&type=template&id=783ff6e4"
import script from "./Favourites.vue?vue&type=script&lang=js"
export * from "./Favourites.vue?vue&type=script&lang=js"

import "./Favourites.vue?vue&type=style&index=0&id=783ff6e4&lang=scss"
script.render = render

export default script